export default "__VITE_ASSET__B0v2TYh1__"